import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash.isempty'
import isNil from 'lodash.isnil'
import { Route, Redirect } from 'react-router-dom'
import { removeLoginToken } from 'src/utils/helpers'

class PrivateRoute extends PureComponent {
  static defaultProps = {
    user: null,
    component: null
  };

  static propTypes = {
    user: PropTypes.object,
  };

  renderPrivateRouteBody = (props) => {
    const { user, component} = this.props

    //React component neeed to be uppercase
    const Component = component //eslint-disable-line

    if (!isEmpty(user) && !isNil(Component)) {
      return <Component {...props}/>
    }

    //edge case when user is not available but token is not deleted
    if (isEmpty(user)) {
      removeLoginToken()
    }
    return (
      <Redirect to={{
        pathname: '/auth/login'
      }}/>
    )
  }

  render() {
    return (
      <Route
        path={this.props.path}
        render={this.renderPrivateRouteBody}
      />
    );
  }
}

export default PrivateRoute;
